export const isProd = window.location.hostname === "wa.riotinto.com";
export const isQA = window.location.hostname === 'uat.wa.riotinto.com';
export const isDev = !isProd && !isQA;
